package com.tregz.design.window

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/** Width buckets, on the Material 3 window size class boundaries (600, 840 and 1200 dp). */
enum class WindowWidth { Compact, Medium, Expanded, Large }

/** Height buckets, on the Material 3 window size class boundaries (480 and 900 dp). */
enum class WindowHeight { Compact, Medium, Expanded }

private val MediumWidth = 600.dp
private val ExpandedWidth = 840.dp
private val LargeWidth = 1200.dp
private val MediumHeight = 480.dp
private val ExpandedHeight = 900.dp

/** The space an app window offers, reduced to the two buckets layouts actually branch on. */
data class WindowClass(val width: WindowWidth, val height: WindowHeight) {

    /** Room for a navigation rail next to the content instead of a bar under it. */
    val hasRail: Boolean get() = width >= WindowWidth.Medium && height != WindowHeight.Compact

    /** Room to show two panes side by side. */
    val hasTwoPanes: Boolean get() = width >= WindowWidth.Expanded && height != WindowHeight.Compact
}

/** NaN or unbounded (infinite) measurements are not a real window: they fall back to the smallest bucket. */
fun windowWidthOf(width: Dp): WindowWidth = when {
    !width.value.isFinite() -> WindowWidth.Compact
    width < MediumWidth -> WindowWidth.Compact
    width < ExpandedWidth -> WindowWidth.Medium
    width < LargeWidth -> WindowWidth.Expanded
    else -> WindowWidth.Large
}

fun windowHeightOf(height: Dp): WindowHeight = when {
    !height.value.isFinite() -> WindowHeight.Compact
    height < MediumHeight -> WindowHeight.Compact
    height < ExpandedHeight -> WindowHeight.Medium
    else -> WindowHeight.Expanded
}

fun windowClassOf(width: Dp, height: Dp): WindowClass =
    WindowClass(windowWidthOf(width), windowHeightOf(height))
